export const AvatarIcon = (props: any) => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M55.2907 25.5673C55.2979 29.4743 54.0156 33.2744 51.6427 36.3783C49.07 39.7686 45.3756 42.1336 41.2197 43.0507C37.0638 43.9678 32.7171 43.3772 28.9565 41.3844C25.196 39.3917 22.2666 36.1267 20.6918 32.1729C19.117 28.219 18.9994 23.834 20.3602 19.8015C21.7209 15.769 24.4712 12.3517 28.1196 10.1604C31.7679 7.969 36.0767 7.14639 40.2758 7.83951C44.4749 8.53263 48.2906 10.6963 51.0413 13.9439C53.7919 17.1915 55.2981 21.3114 55.2907 25.5673Z"
      fill="#fff"
    />
    <path
      d="M69.1607 63.1873V65.6953C69.1636 65.8682 69.1308 66.0398 69.0643 66.1993C68.9977 66.3589 68.8989 66.503 68.774 66.6225C68.6491 66.7421 68.5008 66.8345 68.3385 66.894C68.1762 66.9535 68.0033 66.9788 67.8307 66.9683H7.03068C6.85744 66.9818 6.68332 66.9585 6.51967 66.9001C6.35603 66.8417 6.20656 66.7493 6.08103 66.6292C5.9555 66.5091 5.85677 66.3638 5.79123 66.2028C5.72569 66.0419 5.69485 65.869 5.70072 65.6953V63.1873C5.70072 58.6974 7.48431 54.3915 10.6591 51.2167C13.8339 48.0419 18.1399 46.2583 22.6297 46.2583H52.3267C56.8001 46.2834 61.0817 48.0781 64.2359 51.2501C67.3902 54.4222 69.1608 58.7139 69.1607 63.1873Z"
      fill="#fff"
    />
  </svg>
);
